export enum PaymentMethod {
    UPI = "UPI",
    WALLET = "WALLET",
    CASH = "CASH",
    RAZORPAY = "RAZORPAYAPP"
}